<template>
  <div>
    <CollectionView :endpoint="utilities.path('modules/applications/players/@/applications', playerId)" v-model:reload="reload">
      <template v-slot:header>
        <h4 class="mb-0">{{ translate("applications") }}</h4>
      </template>
      <template v-slot:content="{ items }">
        <div class="card">
          <div class="table-responsive">
            <div class="table">
              <div class="table-header">
                <div class="table-header-cell">{{ translate("status") }}</div>
                <div class="table-header-cell">{{ translate("created_at") }}</div>
                <div class="table-header-cell">{{ translate("replied_at") }}</div>
                <div class="table-header-cell">{{ translate("actions") }}</div>
              </div>
              <div class="table-body">
                <div class="table-row" v-for="item in items" :key="item.id">
                  <div class="table-column" :class="{ 'text-danger': item.status.id === 3, 'text-success': item.status.id === 2, 'text-info': item.status.id === 1 }">{{ item.status.name }}</div>
                  <div class="table-column">{{ utilities.formatDatetime(item.createdAt) }}</div>
                  <div class="table-column">{{ item.repliedAt ? utilities.formatDatetime(item.repliedAt) : "" }}</div>
                  <div class="table-column">
                    <div class="d-flex align-items-center g-2">
                      <TargetedModalView size="large">
                        <template v-slot:target="{ show }">
                          <ButtonView type="soft" color="primary" size="small" @click="show">
                            <i class="fas fa-eye"></i>
                          </ButtonView>
                        </template>
                        <template v-slot:header="{ hide }">
                          <div class="d-flex align-items-center justify-content-between g-4">
                            <h3 class="mb-0">{{ translate("application") }}</h3>
                            <ModalCloseButtonView @click="hide"/>
                          </div>
                        </template>
                        <template v-slot:body="{ hide }">
                          <ApplicationView :application-id="item.id" @reply="hide(); reload = true" @delete="hide(); reload = true"/>
                        </template>
                      </TargetedModalView>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </CollectionView>
  </div>
</template>

<script setup>
import {
  CollectionView,
  utilities,
  ButtonView,
  TargetedModalView,
  ModalCloseButtonView
} from "@/niftybit";
import ApplicationView from "@/systems/modules/applications/ApplicationView.vue";
import {ref} from "vue";

const props = defineProps({
  playerId: String
});

const reload = ref(false);

</script>